import axios from 'axios'
import router from '@/router'
import { Loading, Message } from 'element-ui'
import localCache from '@/utils/cache'

const DEAFULT_LOADING = true

class LCRequest {
  showLoading = false
  instance = null
  constructor(config) {
    // console.log('constructor-config', config)
    this.showLoading = config.showLoading ?? DEAFULT_LOADING
    this.instance = axios.create(config)
    this.instance.interceptors.request.use(
      (config) => {
        const token = localCache.getCache('token')
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }
        if (this.showLoading) {
          Loading.service({
            lock: true,
            background: 'rgba(0, 0, 0, 0.5)'
          })
        }
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )
    this.instance.interceptors.response.use(
      (response) => {
        if (response) {
          Loading.service().close()
          return response
        }
      },
      (error) => {
        Loading.service().close()
        if (error && error.response) {
          if (
            error.response.status == 401 ||
            error.response.status == 452 ||
            error.response.status == 403 ||
            error.response.status == 504 ||
            error.response.status == 502
          ) {
            router.replace('/login')
            Message.error(error.response.data.message || '请重新登录')
          } else {
            Message.error('操作失败')
            return Promise.reject(error)
          }
        }
      }
    )
  }
  request(config) {
    return new Promise((resolve, reject) => {
      this.instance
        .request(config)
        .then((res) => {
          if (res) {
            resolve(res.data)
          } else {
            Message.error(config.tip || '接口请求失败')
          }
        })
        .catch((err) => {
          reject(err)
          return err
        })
    })
  }
  get(config) {
    return this.request({ ...config, method: 'GET' })
  }
  post(config) {
    return this.request({ ...config, method: 'POST' })
  }
}

export default LCRequest
